import React, { useState, useEffect, useRef } from 'react';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Refresh from '@mui/icons-material/Refresh';
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import Primarytheme from './theme';
import HelpIcon from '@mui/icons-material/Help';
import { styled } from '@mui/material/styles';

import FormatListNumberedRtlIcon from '@mui/icons-material/FormatListNumberedRtl';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import PermMediaIcon from '@mui/icons-material/PermMedia';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';


import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import ProjectParameters from './ProjectParameters';


import { getSessionIdToken } from '../auth/apiAuth'

import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarQuickFilter,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    gridDateComparator
}
    from '@mui/x-data-grid';

import axios from 'axios';

const marginsHistory = { marginTop: 40, marginBottom: 32, marginLeft: 32, marginRight: 32 };


export default function AllProjects({ auth }) {

    const navbarRef = useRef();

    const [loading, setLoading] = useState(false);

    const [open, setOpen] = useState(false);

    const [prj_id, setPrjId] = useState('')

    const handleClickOpen = (prj) => {
        setOpen(true);
        setPrjId(prj)
    };

    const handleClose = () => {
        setOpen(false);
    };

    const CustomWidthTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))({
        [`& .${tooltipClasses.tooltip}`]: {
            maxWidth: 800,
        },
    });

    const renderNumUserCells = (params) => {
        const users = params.row.users || [];
        let userList = ""
        users.forEach(u => {
            userList += u.mail + ` [${u.lastLogin && u.lastLogin !== 'Invalid Date' ? u.lastLogin : 'Never'}]` + "\n"
        });
        return (
            <Stack direction="row" alignItems="center" justifyContent="left" width="100%">
                <Typography variant="body2">{users.length}</Typography>
                {userList && (
                    <CustomWidthTooltip
                        title={
                            <Typography variant="caption" sx={{ whiteSpace: 'pre-line' }}>
                                {userList}
                            </Typography>
                        }
                    >
                        <AccountCircleIcon sx={{ fontSize: '1.5em', marginLeft: '0.2em', color: 'grey' }}></AccountCircleIcon>
                    </CustomWidthTooltip>
                )}
            </Stack>
        )
    }

    const renderLimitsCells = (params) => {
        const { rowLimit, imageLimit, gbAssetLimit, gbTotalLimit, prj_id, isLabels } = params.value || {};

        if (isLabels) {
            return <Typography variant="body2" color="text.secondary">—</Typography>;
        }

        return (
            <Stack direction="row" alignItems="center" justifyContent="left" width="100%">

                <Tooltip
                    title={
                        <Typography variant="caption" sx={{ whiteSpace: 'pre-line' }}>
                            <strong>Row Limit: </strong>{rowLimit}
                        </Typography>
                    }
                >
                    <FormatListNumberedRtlIcon sx={{ marginRight: '0.3em', color: !rowLimit ? 'error.main' : (rowLimit === 'no limit' ? 'warning.main' : 'neutral.main') }}></FormatListNumberedRtlIcon>
                </Tooltip>

                <Tooltip
                    title={
                        <Typography variant="caption" sx={{ whiteSpace: 'pre-line' }}>
                            <strong>Image Limit: </strong>{imageLimit}
                        </Typography>
                    }
                >
                    <AddPhotoAlternateIcon sx={{ marginRight: '0.3em', color: !imageLimit ? 'error.main' : (imageLimit === 'no limit' ? 'warning.main' : 'neutral.main') }}></AddPhotoAlternateIcon>
                </Tooltip>

                <Tooltip
                    title={
                        <Typography variant="caption" sx={{ whiteSpace: 'pre-line' }}>
                            <strong>GB Asset Limit: </strong>{gbAssetLimit}
                        </Typography>
                    }
                >
                    <PermMediaIcon sx={{ marginRight: '0.3em', color: !gbAssetLimit ? 'error.main' : (gbAssetLimit === 'no limit' ? 'warning.main' : 'neutral.main') }}></PermMediaIcon>
                </Tooltip>

                <Tooltip
                    title={
                        <Typography variant="caption" sx={{ whiteSpace: 'pre-line' }}>
                            <strong>GB TOTAL Limit: </strong>{gbTotalLimit}
                        </Typography>
                    }
                >
                    <DynamicFeedIcon sx={{ marginRight: '0.3em', color: !gbTotalLimit ? 'error.main' : (gbTotalLimit === 'no limit' ? 'warning.main' : 'neutral.main') }}></DynamicFeedIcon>
                </Tooltip>

                <Button variant="text" onClick={() => { handleClickOpen(prj_id) }} size='small'>
                    Edit
                </Button>

            </Stack>
        )
    }

    const renderActiveCells = (params) => {
        const active = params.row.active.isActive;

        const deactiveMsg = (params) => {
            let msg = ""
            const val = params.row.active;  // ← usa row.active, non value

            if (val.deactivation) {
                msg += "DEACTIVATION:\n"
                for (let p of Object.keys(val.deactivation)) {
                    msg += p + ": "
                    msg += p == "date" ? new Date(val.deactivation[p]).toLocaleDateString() : String(val.deactivation[p])
                    msg += "\n"
                }
            }

            msg += val.disableLaunch ? "DISABLE LAUNCH:\n" + val.disableLaunch + "\n" : ""
            msg += val.billing ? "BILLING:\n" + val.billing + "\n" : ""
            return msg
        }

        return (
            <Stack direction="row" alignItems="center" justifyContent="left" width="100%">
                {active && (
                    <CheckCircleIcon sx={{ color: 'success.main' }}></CheckCircleIcon>
                )}
                {!active && (
                    <Tooltip
                        title={
                            <Typography variant="caption" sx={{ whiteSpace: 'pre-line' }}>
                                {deactiveMsg(params)}
                            </Typography>
                        }
                    >
                        <CancelIcon sx={{ color: 'error.main' }}></CancelIcon>
                    </Tooltip>
                )}
            </Stack>
        )
    }


    const CustomToolbar = () => {
        return (
            <GridToolbarContainer>
                <GridToolbarQuickFilter
                    quickFilterParser={(searchInput) =>
                        searchInput
                            .split(',')
                            .map((value) => value.trim())
                            .filter((value) => value !== '')
                    }
                    //quickFilterProps={{ debounceMs: 500 }}
                    sx={{ p: 1, width: '20%' }}
                />
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
            </GridToolbarContainer>
        );
    }


    const fetchData = async () => {
        return axios.get(`${process.env.REACT_APP_API_BASE_URL}/projects-webapp`,
            {
                headers: {
                    'user_id': auth.userState.user,
                    "content-type": "application/json",
                    "Authorization": await getSessionIdToken(),
                    "type": 'get-all-project-conf-list',
                }

            },
        );
    }



    const refreshData = () => {
        setLoading(true);
        fetchData().then(res => {
            setRows(res.data.projectsList.map((prj, index) => ({
                customer: prj.customer,
                id: prj.project_id,
                bucket: prj.bucket,
                type: prj.is_labels ? 'Labels' : 'Standard',
                limit: { rowLimit: prj.row_limit, imageLimit: prj.image_limit, gbAssetLimit: prj.gb_asset_limit, gbTotalLimit: prj.gb_limit_total, prj_id: prj.project_id, isLabels: prj.is_labels },
                users: prj.userList,
                last_pagination: prj.is_labels ? '—' : prj.lastPagination,
                InDesignVer: prj.is_labels ? '—' : prj.indesign_version,
                active: prj
            })));
        })
            .catch(err => console.error('Error fetching projects'))
            .finally(() => setLoading(false))
    }



    const lastPaginationSortComparator = (d1, d2) => {
        if (!d1 && !d2) return 0;

        if (!d1) return -1;

        if (!d2) return 1;

        const parseDate = (str) => {
            const [date, time] = str.split(', ');
            const [day, month, year] = date.split('/');
            const [hour, minute, second] = time.split(':');
            return new Date(
                Number(year),
                Number(month) - 1,
                Number(day),
                Number(hour),
                Number(minute),
                Number(second)
            );
        };

        const d1date = parseDate(d1);
        const d2date = parseDate(d2);

        return gridDateComparator(d1date, d2date);
    };


    const [rows, setRows] = useState([])
    const columns = [
        {
            field: 'customer',
            renderHeader: () => <strong key={'customer'}>{'Customer'}</strong>,
            flex: 1.5,
        },
        {
            field: 'id',
            renderHeader: () => <strong key={'project_id'}>{'Project id'}</strong>,
            flex: 3,
        },
        {
            field: 'bucket',
            renderHeader: () => <strong key={'bucket'}>{'Bucket'}</strong>,
            flex: 2,
        },
        {
            field: 'type',
            renderHeader: () => <strong key={'type'}>{'Type'}</strong>,
            flex: 1,
        },
        {
            field: 'limit',
            renderHeader: () => <strong key={'limit'}>{'Limits'}</strong>,
            flex: 2,
            renderCell: renderLimitsCells,
            filterable: false,
            sortable: false
        },
        {
            field: 'users',
            renderHeader: () => <strong key={'users'}>{'Num Users'}</strong>,
            flex: 1,
            renderCell: renderNumUserCells,
            type: 'number',
            valueGetter: (value) => (value || []).length,
        },
        {
            field: 'last_pagination',
            renderHeader: () => <strong key={'last_pagination'}>{'Last Pagination'}</strong>,
            flex: 2.5,
            sortComparator: lastPaginationSortComparator,
        },
        {
            field: 'InDesignVer',
            renderHeader: () => <strong key={'InDesignVer'}>{'InDesign V.'}</strong>,
            flex: 1,
        },
        {
            field: 'active',
            renderHeader: () => <strong key={'active'}>{'Active'}</strong>,
            flex: 1,
            renderCell: renderActiveCells,
            type: 'singleSelect',
            valueOptions: [
                { value: true, label: 'Active' },
                { value: false, label: 'Inactive' },
            ],
            valueGetter: (value) => value?.isActive ?? false,
        }
    ];


    useEffect(() => {
        if (auth.userState.userItem) {
            refreshData();
        }
    }, []);




    return (
        <Stack direction='column' sx={{ margin: { ...marginsHistory, marginTop: marginsHistory.marginTop + ((navbarRef.current && navbarRef.current.clientHeight) || 0) }, }} spacing={4}>
            <Card sx={{ padding: '1em' }}>
                <Stack sx={{ m: '1em' }} direction='row' alignItems='center' justifyContent='space-between' spacing={2} >
                    <Typography variant='h5' color='primary' >
                        <b>All Projects</b>
                    </Typography>
                    <Box sx={{ mr: '1em', position: 'relative' }}>
                        <Tooltip title="Refresh data from database">
                            <IconButton onClick={refreshData} > <Refresh /> </IconButton>
                        </Tooltip>
                    </Box>
                </Stack>
                <Stack sx={{ ml: '1em', mr: '1em' }} direction='row' alignItems='center' justifyContent='space-between' spacing={2} >
                    <Typography variant='caption' color='primary' >
                        List of all Pagination projects.
                    </Typography>
                    <Box>
                        {loading && (
                            <Stack direction='row' alignItems='center' >
                                <CircularProgress size="1rem" />
                                <Typography variant='body' color='primary' sx={{ ml: '0.5em' }} >
                                    retrieving information ...
                                </Typography>
                            </Stack>
                        )}
                    </Box>
                </Stack>
                <CardContent sx={{ overflowX: 'hidden' }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        density='compact'
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 15,
                                },
                            },
                            sorting: {
                                sortModel: [{ field: 'id', sort: 'asc' }],
                            },
                        }}
                        pageSizeOptions={[10, 15, 25, 50]}
                        disableRowSelectionOnClick
                        sx={{
                            width: '100%',
                            overflowX: 'hidden',
                            '& .MuiDataGrid-cell': {
                                display: 'flex',
                                alignItems: 'center', // vertical alignment
                            },
                        }}
                        autoHeight
                        disableDensitySelector
                        slots={{ toolbar: CustomToolbar }}
                    />
                </CardContent>
            </Card>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-describedby="edit limit dialog"
                maxWidth='lg'
                fullWidth={true}
            >
                <DialogTitle>{"Edit Limits"}</DialogTitle>
                <DialogContent>
                    <ProjectParameters auth={auth} projects={{ list: [prj_id], retrieving: false, }} specificPrj={true}></ProjectParameters>
                </DialogContent>
            </Dialog>

        </Stack>
    );
}